import OrderCargoOrderDriverSimulationResponse, {
  OrderCargoOrderDriverSimulationResponseBody,
  OrderCargoOrderDriverSimulationResponseBodyModel,
  OrderCargoOrderDriverSimulationResponseBodySimulation,
  OrderCargoOrderDriverSimulationResponseBodySimulations,
} from "../../../../api/raily/order/cargo-order/driver-simulation/order-cargo-order-driver-simulation.response";
import OrderCargoOrderDriverSimulation, {
  OrderCargoOrderDriverSimulationModel,
  OrderCargoOrderDriverSimulationSimulation,
  OrderCargoOrderDriverSimulationSimulations,
} from "./order-cargo-order-driver-simulation";

const createModel = (
  model: OrderCargoOrderDriverSimulationResponseBodyModel,
): OrderCargoOrderDriverSimulationModel => {
  switch (model) {
    case OrderCargoOrderDriverSimulationResponseBodyModel.AB:
      return OrderCargoOrderDriverSimulationModel.AB;
    case OrderCargoOrderDriverSimulationResponseBodyModel.ABA:
      return OrderCargoOrderDriverSimulationModel.ABA;
    case OrderCargoOrderDriverSimulationResponseBodyModel.SABS:
      return OrderCargoOrderDriverSimulationModel.SABS;
  }
};

const createSimulation = (
  simulation: OrderCargoOrderDriverSimulationResponseBodySimulation,
): OrderCargoOrderDriverSimulationSimulation => {
  return {
    bonusRate: simulation.bonusRate,
    contractRate: simulation.contractRate,
    distance: simulation.distance,
    totalCost: simulation.totalCost,
  };
};

const createSimulations = (
  simulations: OrderCargoOrderDriverSimulationResponseBodySimulations,
): OrderCargoOrderDriverSimulationSimulations => {
  return {
    ab: createSimulation(simulations.ab),
    aba: createSimulation(simulations.aba),
    sabs: createSimulation(simulations.sabs),
  };
};

const createBody = (
  body: OrderCargoOrderDriverSimulationResponseBody,
): OrderCargoOrderDriverSimulation => {
  return {
    contractNotes: body.contractNotes,
    driverNotes: body.driverNotes,
    model: createModel(body.model),
    simulations: createSimulations(body.simulations),
  };
};

const create = (
  response: OrderCargoOrderDriverSimulationResponse,
): OrderCargoOrderDriverSimulation => {
  return createBody(response.data);
};

const orderCargoOrderDriverSimulationFactory = {
  create,
};

export default orderCargoOrderDriverSimulationFactory;
